/**
 * 请求地址
 * @type {{dev: string, pro: string}}
 */
export const Host = {
  dev: 'https://api.yibxj.com/api/', // 
  pro: 'https://api.yibxj.com/api/',
}

/**
 * 未登录用户ApiAuth
 */
export const ApiAuth = 'neGkJ50O8BDI4SfnbU6v2TanNjKR6YAS'

/**
 *
 * @type {{bucket: string, endpoint: string, cname: boolean, region: string}}
 */
export const ossConfig = {
  /**
   * @bucket string
   * @description  bucket名称
   */
  bucket: 'tudidaojia',
  // bucket: 'genfee',

  /**
   * @region string
   * @default http://oss-cn-hangzhou.aliyuncs.com
   * @description 此处使用自己绑定的域名 如未绑定可删除此项或设置默认值
   */
  // endpoint: 'https://tudidaojia.oss-cn-beijing.aliyuncs.com',
  // endpoint: 'http://cdn.genfee.cn',
	// 图片上传路径
  endpoint: 'https://tudidaojia.oss-cn-beijing.aliyuncs.com',

  /**
   * @param Boolean cname
   * @default false
   * @description 当使用自定义上传地址 设置为true 否则设置为false
   */
  cname: true,

  /**
   * @param string region
   * @default false
   * @description 区域信息 默认 oss-cn-hangzhou
   */
  region: 'oss-cn-beijing'
}
